"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M20.323 11.927c0 4.597-3.726 8.323-8.323 8.323s-8.323-3.726-8.323-8.323c0-4.113 3-7.548 6.919-8.177v.049c-3.049 1.21-4.887 4.064-4.887 7.452 0 4.306 3.048 6.774 6.29 6.774 3.387 0 6.097-2.758 6.097-6.097 0-2.903-2.274-5.323-5.274-5.323-3.436 0-5.081 3.145-5.081 3.145h-.048s1.548-4.5 6.048-4.5c2.806 0 6.582 2.274 6.582 6.677"
}), 'Oriflame');
